import * as angular from 'angular';
import template from './modal-iframe.template.html';

export default {
  template,
  controller: 'ModalIframeController',
  controllerAs: '$ctrl',
  appendElement: angular.element(document.querySelector('app')),
};



// WEBPACK FOOTER //
// ./src/app/shared/modal/modal-iframe/modal-iframe.component.js